import ButtonElement from "../../../Common/ButtonElement";
import {
  pdf,
  StyleSheet
} from "@react-pdf/renderer";
import Certificate from "./Certificate";
import { MdOutlineFileDownload } from "react-icons/md";

const styles = StyleSheet.create({
  page: { padding: 30, fontSize: 11 },
  header: { fontSize: 16, textAlign: "center", marginBottom: 10, fontWeight: 'bold' },
  subHeader: { marginBottom: 5, textAlign: "center" },
  section: { marginBottom: 10 },
  table: { display: "table", width: "auto", marginBottom: 10 },
  row: { flexDirection: "row" },
  cell: { padding: 5, border: "1px solid #000", flexGrow: 1 },
  bold: { fontWeight: 'bold' },
  footer: { marginTop: 20 }
});

const DownloadDocxButton = ({ vehicleNo, imei, simNo, installDate }) => {
  const handleDownload = async () => {
    const today = new Date().toLocaleDateString("en-GB");
    const doc = <Certificate {...{today, vehicleNo, imei, simNo, installDate}} />;
    const asPdf = pdf();
    asPdf.updateContainer(doc);
    const blob = await asPdf.toBlob();

    const blobURL = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobURL;
    link.download = `GPS_Tracking_Certificate-${vehicleNo}.pdf`;
    link.click();
    URL.revokeObjectURL(blobURL);
  };

  return <ButtonElement text={<MdOutlineFileDownload />} cssClass="more-radius me-1 small-btn" onClick={handleDownload} variant="btn-outline-gps-certificate" loading={false} />
};

export default DownloadDocxButton;
